var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M0 13.545C0 21.0257 6.06431 27.0901 13.545 27.0901C21.0257 27.0901 27.0901 21.0257 27.0901 13.545C27.0901 6.06431 21.0257 0 13.545 0C6.06431 0 0 6.06431 0 13.545Z",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2928_1043",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M0 13.545C0 21.0257 6.06431 27.0901 13.545 27.0901C21.0257 27.0901 27.0901 21.0257 27.0901 13.545C27.0901 6.06431 21.0257 0 13.545 0C6.06431 0 0 6.06431 0 13.545Z",
    fill: "#FA756D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2928_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.87012 27.09C3.87012 32.586 8.32553 37.0414 13.8216 37.0414C19.3176 37.0414 23.773 32.586 23.773 27.09C23.773 21.594 19.3176 19.9028 13.8216 19.9028C8.32553 19.9028 3.87012 21.594 3.87012 27.09Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 12.4392C7.1875 15.9505 10.034 18.797 13.5454 18.797C17.0567 18.797 19.9032 15.9505 19.9032 12.4392C19.9032 8.92781 17.0567 6.0813 13.5454 6.0813C10.034 6.0813 7.1875 8.92781 7.1875 12.4392Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/Profile2.7b9fa5dc3d0fa3568d83708e2ba287f7.svg";
export { ForwardRef as ReactComponent };